import con from '../../../../connection';
var path = '/move';
export var move = function (url) { return function () { return ({
    post: function (param) {
        return con.post(url + path, param);
    },
}); }; };
